import { render, staticRenderFns } from "./UnitInformation.vue?vue&type=template&id=649db27e&scoped=true&lang=pug&"
import script from "./UnitInformation.vue?vue&type=script&lang=ts&"
export * from "./UnitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInformation.vue?vue&type=style&index=0&id=649db27e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649db27e",
  null
  
)

export default component.exports